import {
  aiAnalyzedFileSchema,
  AiAnalyzedFileSource,
} from "@redotech/redo-model/ai-analyzed-file";
import * as z from "zod/v4";

export const getAiAnalyzedFiles = {
  name: "getAiAnalyzedFiles" as const,
  input: z.object({ source: z.enum(AiAnalyzedFileSource).optional() }),
  output: z.object({ data: z.array(aiAnalyzedFileSchema) }),
};

export const getAiAnalyzedFileContent = {
  name: "getAiAnalyzedFileContent" as const,
  input: z.object({ fileUrl: z.string() }),
  output: z.object({ content: z.string() }),
};
